export default {

  computed: {
    state() {
      return this.$store.state.assetState;
    },
  },

  methods: {
    fetchAssetState(id) {
      this.$nextTick(() => {
        window.axios
          .get(`/asset/${id}/state`)
          .then(({
            data,
          }) => this.updateStateState(data))
          .catch((error) => {
            throw new Error(error);
          });
      });
    },

    updateStateState(asset) {
      const state = {
        state: asset.state,
        stateLabel: asset.stateLabel,
        color: asset.color,
        version: asset.version,
        withCounterparty: asset.withCounterparty,
      };
      this.$store.dispatch('assetStateUpdated', state);
    },
  },
};
